import React from 'react';
import { useFormContext } from 'react-hook-form';

import { LayoutDataType } from '../../types';

import { ScreenAboutLook as ScreenAboutLookFemale } from './Female';
import { ScreenAboutLook as ScreenAboutLookMale } from './Male';

export const ScreenAboutLook: React.FC = () => {
  const form = useFormContext<LayoutDataType>();
  const gender = form.watch('gender');

  if (gender === 'male') {
    return <ScreenAboutLookMale />;
  }

  return <ScreenAboutLookFemale />;
};
